import { render, staticRenderFns } from "./GenericSvg.vue?vue&type=template&id=3b4a2bde&scoped=true&"
import script from "./GenericSvg.vue?vue&type=script&lang=js&"
export * from "./GenericSvg.vue?vue&type=script&lang=js&"
import style0 from "./GenericSvg.vue?vue&type=style&index=0&id=3b4a2bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a2bde",
  null
  
)

export default component.exports